<template>
  <div>
    <el-card
      v-loading="loading"
      shadow="always"
      :body-style="{ padding: '20px' }"
    >
      <div slot="header">
        <span v-if="from && to"
          >{{ from.bestchangeKey }} - {{ to.bestchangeKey }}</span
        >
        <span v-if="city">{{ city.name }}</span>
      </div>
      <!-- <div style="max-height: 300px; overflow:scroll;">
        <pre>
          {{ from }}
        </pre>
      </div> -->
      <el-table :data="tableData" border :row-class-name="tableRowClassName">
        <el-table-column min-width="50" prop="exchangeName" label="">
          <template v-slot="scope">
            {{ scope.row.place }}
          </template>
        </el-table-column>
        <el-table-column min-width="150" prop="exchangeName" label="Обменник">
          <template v-slot="scope">
            {{ scope.row.exchangeName }}
          </template>
        </el-table-column>
        <el-table-column min-width="150" prop="in" label="Отдаете">
          <template v-slot="scope">
            {{ scope.row.in }} {{ scope.row.inValute.bestchangeKey }}
          </template>
        </el-table-column>
        <el-table-column min-width="150" prop="out" label="Получаете">
          <template v-slot="scope">
            {{ scope.row.out }} {{ scope.row.outValute.bestchangeKey }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { calculateCrossRate } from "@/api";
export default {
  name: "BestchangePreviewComponent",
  props: {
    inputData: {
      type: Object,
      default() {
        return {};
      }
    },
    closeHandler: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      dbg: null,
      from: null,
      to: null,
      city: null
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      return row.className;
    }
  },
  async mounted() {
    // this.tableData = [
    //   {
    //     exchangeName: "ex1",
    //     in: 1,
    //     out: 52450
    //   },
    //   {
    //     exchangeName: "ex2",
    //     in: 1,
    //     out: 52400
    //   },
    //   {
    //     exchangeName: "ex3",
    //     in: 1,
    //     out: 52350
    //   },
    //   {
    //     exchangeName: "ex4",
    //     in: 1,
    //     out: 52320
    //   }
    // ];
    try {
      this.loading = true;
      const { data } = await calculateCrossRate({ crossrate: this.inputData });
      if (data.status && data.result) {
        this.from = data.result.crossRate.from;
        this.to = data.result.crossRate.to;
        this.city = data.result.crossRate.city;
        const rawRates = [
          ...data.result.filteredRates.map((r, i) => {
            return {
              ...r,
              place: i + 1,
              className: ""
            };
          }),
          data.result.newRate
            ? {
                exchangeData: { name: "МЫ БУДЕМ ТУТ" },
                rate: data.result.newRate,
                className: "newrate"
              }
            : undefined,
          data.result.limitRate
            ? {
                exchangeData: { name: "ЛИМИТ" },
                rate: data.result.limitRate,
                className: "limitrate"
              }
            : undefined,
          data.result.ourRate
            ? {
                exchangeData: { name: "НАШ ВНУТРЕННИЙ КУРС" },
                rate: data.result.ourRate,
                className: "ourrate"
              }
            : undefined
        ]
          .filter(r => !!r)
          .sort((a, b) => b.rate - a.rate);
        this.tableData = rawRates.map((r, i) => {
          return {
            ...r,
            exchangeName: r.exchangeData.name,
            in: data.result.ourRate > 1 ? 1 : 1 / r.rate,
            inValute: data.result.crossRate.from,
            out: data.result.ourRate > 1 ? r.rate : 1,
            outValute: data.result.crossRate.to
          };
        });
      }
      this.dbg = data.result;
    } catch (error) {
      // console.log(error);
      this.handleResponseError(error);
      this.closeHandler();
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style>
.el-table .newrate {
  background-color: #67c23a;
}
.el-table .limitrate {
  background-color: #f56c6c;
}
.el-table .ourrate {
  background-color: #909399;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/BestchangePreview.vue